import React, { useCallback, useState } from 'react';
import { connect } from 'react-redux';
import { VStack } from '@adc/parallax-component-library';
import { useApiError } from 'Hooks';
import { Button, Footer, Header, LogoActionBar, Main, RichText, ScrollContainer, Spinner, } from 'Components/utility';
import i18n from 'Utilities/i18n';
import mediator from 'Utilities/mediator';
import { getAuthSession } from 'Utilities/session';
import { updateConsent } from 'Services/consent';
const mapStateToProps = ({ env: { app }, register: { patientId } }) => {
    return {
        app,
        patientId,
    };
};
const connector = connect(mapStateToProps);
const HipaaConsent = ({ app, patientId }) => {
    const [loading, setLoading] = useState(false);
    const { showApiErrorModal } = useApiError();
    const handleSubmitHipaaAction = useCallback(async (action) => {
        try {
            setLoading(true);
            const authSession = getAuthSession();
            if (authSession) {
                await updateConsent(patientId, action, app, 'hipaa', authSession.accessToken);
                mediator.publish('router:navigate', '/rwe');
                return;
            }
            showApiErrorModal();
        }
        catch {
            showApiErrorModal();
        }
        finally {
            setLoading(false);
        }
    }, [app, patientId, showApiErrorModal]);
    return (React.createElement(Main, null,
        React.createElement(LogoActionBar, { titleTestID: "Hipaa.actionTitle", title: i18n.t('Hipaa.title'), noActionButton: true }),
        loading && React.createElement(Spinner, null),
        React.createElement(ScrollContainer, null,
            React.createElement(Header, { titleTestID: "Hipaa.title", title: i18n.t('Hipaa.title') }),
            React.createElement(VStack, { padding: "$4" },
                React.createElement(RichText, { text: i18n.t('Hipaa.content.hipaaRichText.bodyText') }))),
        React.createElement(Footer, { customProps: React.createElement(VStack, { padding: "$4" },
                React.createElement(Button, { onPress: () => handleSubmitHipaaAction('accept'), testID: "Hipaa.accept", label: i18n.t('Global.microcopy.common.accept'), "aria-label": i18n.t('Global.microcopy.common.accept'), marginBottom: "$4" }),
                React.createElement(Button, { onPress: () => handleSubmitHipaaAction('decline'), variant: "tertiary", testID: "Hipaa.decline", label: i18n.t('Global.microcopy.common.decline'), "aria-label": i18n.t('Global.microcopy.common.decline') })) })));
};
export default connector(HipaaConsent);
